<template>
  <qx-custom-form
    :noSubBtn="true"
    ref="baseForm"
    :formData="baseForm"
    labelWidth="120px"
  >
    <section slot="submit" style="margin-left: 40px">
      <el-button type="primary" @click="search">
        <i class="el-icon-search" />
        查询
      </el-button>
    </section>
  </qx-custom-form>
</template>

<script>
import {
  cityCustomerOrderQueryPage,
} from 'api/distribution';
export default {
  data () {
    return {
      baseForm: {
        inline: true,
        form: [
          {
            label: '客户名称',
            value: 'customerName',
            placeholder: '请输入客户名称',
            type: 'input',
          },
          {
            label: '下单日期',
            value: 'orderTime',
            type: 'date',
            default: [],
            placeholder: '请选择下单日期',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '收货方',
            value: 'consignee',
            placeholder: '请输入收货方',
            type: 'input',
          },
          {
            value: 'submit',
            slot: true,
          },
        ],
      },
    };
  },
  methods: {

    async search () {
      const formData = await this.$refs.baseForm.sub();
      if (formData.orderTime && formData.orderTime.length) {
        formData.startTime = this.formatDate(formData.orderTime[0]) + ' 00:00:00';
        formData.endTime = this.formatDate(formData.orderTime[1]) + ' 23:59:59';
        delete formData.orderTime;
      }
      const res = await cityCustomerOrderQueryPage({
        page: 1,
        rows: 10000,
        // 过滤不符合条件的订单
        orderState: 0,
        ...formData,
      });
      if (res.items && res.items.length) {
        this.$emit('search', res.items);
      }
    },
    async init (data = {}) {
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
